var _radialGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 540,
    width: 540,
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cy: "30%",
    cx: "30%",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.97172 0 0 .9754 5.344 5.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a2e9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#734ce2",
    offset: "100%"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14)",
    strokeWidth: 8,
    stroke: "url(#a)",
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02 74.981c-22.969-22.969-49.519-41.097-78.912-53.882a7.446 7.446 0 1 0-5.939 13.654c27.672 12.037 52.678 29.114 74.321 50.757 45.539 45.54 70.619 106.088 70.619 170.49s-25.08 124.95-70.619 170.49c-45.54 45.54-106.087 70.619-170.49 70.619S131.05 472.03 85.51 426.49C39.971 380.95 14.891 320.402 14.891 256S39.971 131.05 85.51 85.51C131.05 39.97 191.598 14.891 256 14.891c21.259 0 42.322 2.745 62.602 8.158 3.974 1.063 8.053-1.3 9.114-5.273s-1.3-8.053-5.273-9.113C300.91 2.914 278.556 0 256 0 187.62 0 123.333 26.629 74.98 74.981 26.628 123.333 0 187.621 0 256s26.628 132.667 74.98 181.019C123.333 485.371 187.62 512 256 512s132.667-26.629 181.02-74.981C485.372 388.667 512 324.379 512 256s-26.628-132.667-74.98-181.019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.218 250.503c0-2.229-.609-4.375-1.687-6.258L267.034 73.634A12.62 12.62 0 0 0 256 67.133a12.618 12.618 0 0 0-11.034 6.502L150.46 244.259c-2.717 4.428-2.088 12.406 3.698 16.574l94.603 66.287a12.581 12.581 0 0 0 6.608 2.253c.209.018.418.032.631.032 2.604 0 5.107-.79 7.238-2.284l94.602-66.287a12.626 12.626 0 0 0 5.378-10.331zm-30.851-28.18-68.943-48.308-.011-76.186zm-106.186-23.525a7.444 7.444 0 0 0-10.37-1.825l-36.179 25.35 68.89-124.378.03 210.846-83.189-58.289 58.992-41.335a7.443 7.443 0 0 0 1.826-10.369zm37.263 109.996-.016-116.595 83.208 58.303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.445 293.788 256 351.556l-82.444-57.768a8.485 8.485 0 0 0-10.792.879 8.485 8.485 0 0 0-1.129 10.769l83.871 125.795c2.184 3.276 5.743 5.297 9.636 5.562 3.964.244 8.09-1.129 11.354-5.563l83.87-125.794a8.483 8.483 0 0 0-1.131-10.77 8.482 8.482 0 0 0-10.79-.878zm-145.496 31.771 55.605 38.962v44.439zm70.496 83.402v-44.439l55.605-38.963z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeth);
export default __webpack_public_path__ + "static/media/neth.832ca487dfcd9a1be8f9f9f0242e0171.svg";
export { ForwardRef as ReactComponent };